export default {
      id: "ic_expand-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.svg#ic_expand",
      toString: function () {
        return this.url;
      }
    }